
export const navLinks = [
    { href: "/", label: "<Home />",dir:"/" },
    { href: "/about", label: "<About Me />",dir:"/about" },
    { href: "/project", label: "<Projects />",dir:"/project" },
    { href: "/about#contact", label: "<Contact Me />",dir:"/about#contact" },
    { href: "/resume", label: "<Resume />",dir:"/resume" },
];


export const testimonial = [
    {
      "message": "message",
      "by": "dev",
      "post": "Dev"
    },
    {
      "message": "message",
      "by": "dev",
      "post": "Dev"
    },
    {
      "message": "message",
      "by": "dev",
      "post": "Dev"
    },
  ]



  


export const SkillData=[
    {
        id:1,
        vclass:false,
        iclass:"devicon-html5-plain colored"
    },
    {
        id:2,
        vclass:false,
        iclass:"devicon-css3-plain colored"
    },
    {
        id:4,
        vclass:false,
        iclass:"devicon-javascript-plain colored"
    },
    {
        id:5,
        vclass:false,
        iclass:"devicon-bootstrap-plain colored"
    },
    {
        id:6,
        vclass:false,
        iclass:"devicon-react-plain colored"
    },
    {
        id:7,
        vclass:false,
        iclass:"devicon-tailwindcss-plain colored"
    },
    {
        id:8,
        vclass:false,
        iclass:"devicon-django-plain "
    },
    {
        id:9,
        vclass:false,
        iclass:"devicon-nodejs-plain colored  icn-visible"
    },
    {
        id:10,
        vclass:false,
        iclass:"devicon-mongodb-plain colored  icn-visible"
    },
    {
        id:11,
        vclass:false,
        iclass:"devicon-c-plain colored"
    },
    {
        id:12,
        vclass:false,
        iclass:"devicon-cplusplus-plain colored"
    },
    {
        id:13,
        vclass:false,
        iclass:"devicon-python-plain colored"
    },
    // {
    //     id:14,
    //     vclass:false,
    //     iclass:"devicon-java-plain colored"
    // },
    {
        id:15,
        vclass:false,
        iclass:"devicon-linux-plain colored"
    },
    {
        id:16,
        vclass:false,
        iclass:"devicon-git-plain colored"
    },
    {
        id:17,
        vclass:false,
        iclass:"devicon-github-original "
    },
    {
        id:18,
        vclass:false,
        iclass:"devicon-azure-plain colored"
    },
    {
        id:19,
        vclass:false,
        iclass:"devicon-docker-plain colored"
    },
    
    {
        id:20,
        vclass:false,
        iclass:"devicon-mysql-plain colored"
    },
    
];

<div>
    <span className='text-fLetter'>.</span>
    <span className='text-fLetter'>..</span>
</div>  

//  <div>
//     <p className="text-primary">With great power comes... the responsibility to resist the urge to run '<span className="text-bold ">sudo rm -rf /*</span>'. Trust me, your computer will thank you, and so will the digital elves living in its circuits! 🧝✨ Keep the code mischievous, not malicious! 😉👾</p>
// </div> 


const gitSVG = "<svg width='20px' height='20px' viewBox='0 0 128 128'><g fill='white'><path fill-rule='evenodd' clip-rule='evenodd' d='M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z'></path><path d='M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0'></path></g></svg>"

const linkSvg = "<img src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-plain.svg />"
  
export const terminalCommands ={
    '.secret':"<div><p className='text-primary'>With great power comes... the responsibility to resist the urge to run <span className='font-bold'>sudo rm -rf /*</span>. Trust me, your computer will thank you, and so will the digital elves living in its circuits! 🧝✨ Keep the code mischievous, not malicious! 😉👾</p></div>",

    'all':"<div className='flex flex-wrap gap-3'><span className='text-fLetter'>.</span>    <span className='text-fLetter'>..</span></div>  ",
    
    '-a':" <div className='flex flex-wrap gap-3'><span className='text-fLetter'>.</span><span className='text-fLetter'>..</span><span className='text-white'>.secret</span></div>",

    'About':"<div className='flex flex-wrap gap-3'><span className='text-white'>skills</span><span className='text-white'>testimonial</span><span className='text-white'>contact</span></div> ",

    'contact':`<div className=''><p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="12" viewBox="0 0 512 512"><path fill="#63E6BE" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg> prasadkhatake20@gmail.com</p>
    <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="11.625" viewBox="0 0 496 512"><path fill="#63E6BE" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>  <a href='https://github.com/hackerspider09'>github.com/hackerspider09</a> </p>
    <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="10.5" viewBox="0 0 448 512"><path fill="#63E6BE" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg> <a href='https://www.linkedin.com/in/prasad-khatake'>linkedin.com/in/prasad-khatake</a> </p></div> `,

    'skills':"<div className='flex flex-wrap gap-3'><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>python</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>CPP</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>Django</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>Docker</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>Azure</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>Git</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>My-SQL</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>GitHub</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>React JS</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>DSA</span><span className='px-2 py-1 bg-gray-700 rounded-2xl text-fLetter'>OOP</span></div> ",

    'testimonial':"<div className=''><h1 className='text-white'>Dev</h1></div> ",

    'Project':"<div className='flex flex-wrap gap-3'><span className='text-fLetter'>Projects</span></div> ",

    'home':`<div className='flex flex-wrap gap-3'><span className='text-white'>terminal</span><span className='text-fLetter'>About</span><span className='text-fLetter'>Project</span><span className='text-fLetter'>Resume</span></div>`,

    '/':`<div className='flex flex-wrap gap-3'><span className='text-fLetter'>About</span><span className='text-fLetter'>Project</span><span className='text-fLetter'>Resume</span></div>`,

    'Resume':"<div className='flex flex-wrap gap-3'><span className='text-white'>resume.pdf</span></div> ",

// <span className='text-fLetter'>home</span>
    'ls':"<div className='flex flex-row flex-wrap gap-3'><span className='text-white'>resume.pdf</span><span className='text-white'>terminal</span><span className='text-fLetter'>about</span><span className='text-fLetter'>project</span><span className='text-fLetter'>resume</span></div>",

    'sudo':"Bhai hacker hai hacker hacker",

    'infofetch':`<div className=' text-fLetter flex flex-row gap-6 max-xl:flex-col max-xl:items-center'><div><pre>.------------------.<br/>| .--------------. | <br/>| |   ______     | |<br/>| |  |_   __ \\   | | <br/>| |    | |__) |  | | <br/>| |    |  ___/   | |    <br/>| |   _| |_      | | <br/>| |  |_____|     | | <br/>| |              | |   <br/>| '--------------' | <br/>'------------------' </pre>       </div>       
    <div className=' text-primary'>        
        <div>          
            <p><i className='fa-solid fa-info'></i> Info Reveal</p>
            <p>--------------------</p>
        </div>
        <div>
            <p className='text-2xl'><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="25" width="25" viewBox="0 0 576 512"><path fill="#63E6BE" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg> About</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="10.5" viewBox="0 0 448 512"><path fill="#63E6BE" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg> Prasad Balaji Khatake</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="15" viewBox="0 0 640 512"><path fill="#63E6BE" d="M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H256V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"/></svg> BE-EnTC | PICT</p>
        </div>
        <div>
            <p className='text-2xl'><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="25" width="25" viewBox="0 0 512 512"><path fill="#63E6BE" d="M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"/></svg> Contact</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="12" viewBox="0 0 512 512"><path fill="#63E6BE" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg> prasadkhatake20@gmail.com</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="11.625" viewBox="0 0 496 512"><path fill="#63E6BE" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>  <a href='https://github.com/hackerspider09'>github.com/hackerspider09</a> </p>
            <p><svg xmlns="http://www.w3.org/2000/svg" className='inline-block' height="12" width="10.5" viewBox="0 0 448 512"><path fill="#63E6BE" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg> <a href='https://www.linkedin.com/in/prasad-khatake'>linkedin.com/in/prasad-khatake</a> </p>
        </div>
        <div className='flex'>
            <div className='bg-red w-5 h-5'></div>
            <div className='bg-red w-5 h-5'> </div>
            <div className='bg-red w-5 h-5'> </div>
            <div className='bg-red w-5 h-5'> </div>
            <div className='bg-red w-5 h-5'> </div>
            <div className='bg-red w-5 h-5'> </div>
        </div>
        </div>
        </div></div>`,


    'help':`<div className='text-primary'>
    <p><strong>Commands available:</strong></p>
    <table>
        <tbody>
            <tr>
                <td className='text-fLetter '>pwd</td>
                <td className='pl-16'>Print the current working directory.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>sudo</td>
                <td className='pl-16'>Execute a command with elevated privileges.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>cd</td>
                <td className='pl-16'>Change the current directory.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>ls</td>
                <td className='pl-16'>List the contents of the current directory. Files are denoted by white color, directories by green.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>xdg-open</td>
                <td className='pl-16'>Use this to open PDF files.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>whoami</td>
                <td className='pl-16'>Display the username.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>date</td>
                <td className='pl-16'>Show the current date.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>clear</td>
                <td className='pl-16'>Clear the terminal screen.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>github</td>
                <td className='pl-16'>To visit my GitHub profile.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>linkedin</td>
                <td className='pl-16'>To visit my LinkedIn profile.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>infofetch</td>
                <td className='pl-16'>Get short details about me.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>cat</td>
                <td className='pl-16'>Display content of a file.</td>
            </tr>
            <tr>
                <td className='text-fLetter'>email</td>
                <td className='pl-16'>Send an email. Pressing "Enter" will reveal additional fields.</td>
            </tr>
        </tbody>
    </table>
</div>`
}

        //    .----------------. 
        //    | .--------------. |
        //    | |   ______     | |
        //    | |  |_   __ \    | |
        //    | |    | |__) |  | |
        //    | |    |  ___/   | |
        //    | |   _| |_      | |
        //    | |  |_____|     | |
        //    | |              | |
        //    | '--------------' |
        //    '----------------' 




export const project = [
    {
        "id": 1,
        "title": "Credenz'23 Clash-MCQ Platform",
        "desc": "MCQ platform for the annual tech event Credenz.This platform facilitates engaging multiple-choice questions.",
        "techstack": ["Django", "HTML", "CSS", "JavaScript", "AJAX", "SQL", "Azure", "Docker"],
        "gitlink": "https://github.com/PISB-Backend-SIGs/Clash-1",
        "deplink": "",
        "articlelink":""
    },
    {
        "id": 2,
        "title": "CTD NCC/RC OJ",
        "desc": "Online judge for the tech event CTD (Credenz Tech Days) featuring a comprehensive code evaluation system. Users submit code, which undergoes rigorous testing against predefined test cases.",
        "techstack": ["Django", "Django REST Framework", "React", "SQL", "Docker", "Azure"],
        "gitlink": "https://github.com/CTD-23/NCC-Backend",
        "deplink": "https://ctdrc23.netlify.app",
        "articlelink":""
    },
    {
        "id": 3,
        "title": "Portfolio",
        "desc": "A personal tech portfolio showcasing projects, skills, and experiences.",
        "techstack": ["React", "Tailwindcss"],
        "gitlink": "https://github.com/hackerspider09/newPortfolio",
        "deplink": "https://prasadkhatake.netlify.app",
        "articlelink":""
    },
    {
        "id": 4,
        "title": "Floating Sticky Notes",
        "desc": "A Java-based application that creates floating sticky notes on the screen. These notes persistently stick to the sides of the screen and allow users to create, edit, and delete notes.",
        "techstack": ["Java"],
        "gitlink": "https://github.com/hackerspider09/FloatingNotes",
        "deplink": "",
        "articlelink":""
    },
    {
        "id": 5,
        "title": "Bhau-Lang",
        "desc": "BhauLang is a toy programming language inspired by BhaiLang. It includes basic constructs for variable declaration, printing, conditionals, and loops.",
        "techstack": ["Python"],
        "gitlink": "https://github.com/hackerspider09/BhauLang",
        "deplink": "https://pypi.org/project/BhauLang/",
        "articlelink":"https://prasadkhatake.medium.com/how-i-built-my-own-programming-language-871c605ca9c4"
    },
    {
        "id": 6,
        "title": "Mini-Nginx",
        "desc": "A lightweight web server and reverse proxy built in Python, inspired by Nginx. It follows an event-driven, single-threaded architecture using async I/O for efficient request handling.",
        "techstack": ["Python"],
        "gitlink": "https://github.com/hackerspider09/Mini-Nginx",
        "deplink": "",
        "articlelink":"https://prasadkhatake.medium.com/inside-nginx-a-simple-guide-to-its-internal-architecture-09ca7d269cae"
    }
    
]

export const banner = `██████╗ ██████╗  █████╗ ███████╗ █████╗ ██████╗ 
██╔══██╗██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗
██████╔╝██████╔╝███████║███████╗███████║██║  ██║
██╔═══╝ ██╔══██╗██╔══██║╚════██║██╔══██║██║  ██║
██║     ██║  ██║██║  ██║███████║██║  ██║██████╔╝
╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚═════╝ 
                                                `


export const emailBanner = `
______________________________
<          Send Mail            >
------------------------------
       \\   ^__^
        \\  (oo)\\_______
           (__)\\       )\\/\\
               ||----w |
               ||     ||
`